// extracted by mini-css-extract-plugin
export default {"forwardingProtocols":"ProtectedDomain_forwardingProtocols__yfxTv","forwardingField":"ProtectedDomain_forwardingField__YgM7T","errorText":"ProtectedDomain_errorText__LMsyd"};